<template>
  <div class="group-card">
    <div class="group-card__title">
      <slot name="title">{{ title }}</slot>
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  name: "GroupCard",
  props: {
    title: String
  }
};
</script>

<style lang="scss">
.group-card {
  display: flex;
  flex-direction: column;

  &__title {
    font-size: 15px;
    color: colors(palette-4);
    margin-bottom: 10px;
    margin-left: 16px;
  }
}
</style>
